import { TranslationData } from "@/common/lib/types";
import Button from "@/components/ui/button/Button";
import Modal from "@/components/ui/modal_new/Modal";
import { useMediaQuery } from "@/hooks/useMediaQuery";
import { getCloudinaryURL } from "@/utils/cloudinary";
import Image from "next/image";
import NoImageSrc from "@/assets/images/no_image.svg";

interface IProps {
  open: boolean;
  imgURL: string;
  onCancel: () => void;
  onAccept: () => void;
  translations?: TranslationData;
}

const RemoveFavorite = ({ imgURL, onAccept, onCancel, open, translations }: IProps) => {
  const isSmallScreen = useMediaQuery("(max-width: 640px)", {
    defaultValue: false,
    initializeWithValue: true,
  });

  return (
    <Modal
      onClose={onCancel}
      isOpen={open}
      slots={{
        container: { className: "px-10 py-8 sm:px-6 sm:py-5" },
        close: {
          container: {
            className: "mb-0",
          },
          visible: true,
        },
      }}
    >
      <div className="flex flex-col gap-5 sm:flex-row">
        <div className="flex aspect-[130/157] h-[157px] items-center justify-center">
          <Image
            src={getCloudinaryURL(imgURL) ?? NoImageSrc}
            alt={"favorite-i"}
            height={158}
            width={157}
            className="pb-3"
          />
        </div>
        <div className="flex flex-col justify-between gap-5 sm:gap-0">
          <h3 className="max-w-[16rem] text-center text-sm font-semibold sm:text-start sm:text-base">
            {translations?.favorites?.favorite_remove_item_overlay_description}
          </h3>
          <div className="flex flex-col gap-4 sm:flex-row items-center">
            <Button
              onClick={onCancel}
              className="order-2 flex h-9 max-w-[125px] items-center justify-center whitespace-nowrap text-[13px] sm:order-1"
              variant={isSmallScreen ? "link" : "outlined"}
            >
              {translations?.favorites?.favorite_remove_item_overlay_cancel_button_label}
            </Button>
            <Button
              className="order-1 flex h-9 max-w-[155px] items-center justify-center whitespace-nowrap text-[13px] sm:order-2"
              onClick={onAccept}
            >
              {translations?.favorites?.favorite_remove_item_overlay_confirm_button_label}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default RemoveFavorite;
